export default __webpack_public_path__ + "media/images/react_icons/doorcode-b825bc7c4499116c2ad33de21061ea23.svg";